export default "<div id=\"header-user\"></div>\n<div id=\"app-title\"><%- text %></div>\n<div id=\"promo-code-button\"></div>\n";